export default {
  path: "/user/cpa/eventos",
  component: () => import("@/views/user/cpa/eventos/EventosLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "eventos-dashboard",
      component: () =>
        import("@/views/user/cpa/eventos/EventosDashboard.vue"),
    },
    {
      path: "nuevo",
      name: "eventos-nuevo",
      component: () =>
        import("@/views/user/cpa/eventos/EventoEditorView.vue"),
    },
    {
      path: ":eventId",
      name: "eventos-editar",
      component: () =>
        import("@/views/user/cpa/eventos/EventoEditorView.vue"),
      props: true,
    },
    {
      path: ":eventId/pagos",
      name: "eventos-pagos",
      component: () =>
        import("@/views/user/cpa/eventos/EventoPagosView.vue"),
      props: true,
    },
    {
      path: ":eventId/dashboard",
      name: "eventos-metricas",
      component: () =>
        import("@/views/user/cpa/eventos/EventoMetricasView.vue"),
      props: true,
    },
    {
      path: ":eventId/staff",
      name: "eventos-staff",
      component: () =>
        import("@/views/user/cpa/eventos/EventoStaffView.vue"),
      props: true,
    },
    {
      path: ":eventId/validar",
      name: "eventos-validar",
      component: () =>
        import("@/views/user/eventos/EventoValidarEntradaView.vue"),
      props: true,
    },
  ],
};
